import { createReducer, on } from "@ngrx/store";
import {
  fetchCommissionGroup,
  fetchCommissionGroupSuccess,
  fetchCommissionGroupFailure,
  getCommissionGroup,
  getCommissionGroupFailure,
  getCommissionGroupSuccess,
  deleteCommissionGroup,
  deleteCommissionGroupSuccess,
  deleteCommissionGroupFailure,
  addCommissionGroup,
  addCommissionGroupSuccess,
  addCommissionGroupFailure,
  updateCommissionGroup,
  updateCommissionGroupSuccess,
  updateCommissionGroupFailure,
  fetchCommissionGroupsByAffiliate,
  fetchCommissionGroupsByAffiliateSuccess,
  fetchCommissionGroupsByAffiliateFailure
} from "./commission-groups.actions";

import { IState } from "@models/index";

const initialState: IState = {
  isLoaded: false,
  data: [],
  selectedItem: {},
  error: null,
  total: 0,
  maxPages: 0,
  perPage: 0,
  currentPage: 0
};

const _commissionGroupReducer = createReducer(
  initialState,
  on(fetchCommissionGroup, (state, { page, campaignID, filterOptions }) => {
    const payload = {
      isLoaded: true
    }

    return { ...state, ...payload };
  }),
  on(fetchCommissionGroupSuccess, (state, { commissionGroup }) => {
    const payload = {
      isLoaded: true,
      data: commissionGroup.data,
      total: commissionGroup.total,
      maxPages: commissionGroup.maxPages,
      perPage: commissionGroup.perPage,
      currentPage: commissionGroup.currentPage,
      selectedItem: {}
    };

    return { ...state, ...payload };
  }),
  on(fetchCommissionGroupFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error
    };
    return { ...state, ...payload };
  }),


  on(fetchCommissionGroupsByAffiliate, (state, { page, affiliateID, filterOptions }) => {
    const payload = {
      isLoaded: false
    };
    return { ...state, ...payload };
  }),
  on(fetchCommissionGroupsByAffiliateSuccess, (state, { commissionGroup }) => {
    const payload = {
      isLoaded: true,
      data: commissionGroup.data,
      total: commissionGroup.total,
      maxPages: commissionGroup.maxPages,
      perPage: commissionGroup.perPage,
      currentPage: commissionGroup.currentPage,
      selectedItem: {}
    };
    return { ...state, ...payload };
  }),
  on(fetchCommissionGroupsByAffiliateFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error
    };
    return { ...state, ...payload };
  }),

  on(getCommissionGroup, (state, { id }) => {
    const payload = {
      isLoaded: false,
      isSaved: false
    };
    return { ...state, ...payload };
  }),
  on(getCommissionGroupSuccess, (state, { commissionGroup }) => {
    const payload = {
      isLoaded: true,
      selectedItem: commissionGroup
    };
    return { ...state, ...payload };
  }),
  on(getCommissionGroupFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error
    };
    return { ...state, ...payload };
  }),
  on(deleteCommissionGroup, (state, { id }) => {
    const payload = {
      isLoaded: false
    };
    return { ...state, ...payload };
  }),
  on(deleteCommissionGroupSuccess, (state, { id }) => {
    const payload = {
      isLoaded: true,
      data: state.data.filter(item => item.id !== id)
    };
    return { ...state, ...payload };
  }),
  on(deleteCommissionGroupFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error
    };
    return { ...state, ...payload };
  }),
  on(addCommissionGroup, (state, { commissionGroup }) => {

    return state;
  }),
  on(addCommissionGroupSuccess, (state, { commissionGroup }) => {
    let total: number = state.total;
    
    if (state.total < state.perPage) {
      total += 1;
    } else {
      state.data.splice(state.data.length - 1, 1);
    }

    const payload = {
      total,
      data: [{ ...commissionGroup }, ...state.data]
    };
    return { ...state, ...payload };
  }),
  on(addCommissionGroupFailure, (state, { error }) => {
    const payload = {
      error
    };
    return { ...state, ...payload };
  }),
  on(updateCommissionGroup, (state, { commissionGroup }) => {
    const payload = {
      isLoaded: false
    }
    return { ...state, ...payload };
  }),
  on(updateCommissionGroupSuccess, (state, { commissionGroup }) => {
    const index = state.data.findIndex(com => com.id === commissionGroup.id);
    state[index] = commissionGroup;
    const payload = {
      isLoaded: true,
      selectedItem: commissionGroup
    }
    return { ...state, ...payload };
  }),
  on(updateCommissionGroupFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error
    };
    return { ...state, ...payload };
  }),
);

export function commissionGroupReducer(state, action) {
  return _commissionGroupReducer(state, action);
}
